import { Button, Stack, Typography } from "@mui/material"
import { Frame } from "../../components/layouts/Frame"
import { Route, Routes, useNavigate } from "react-router-dom";
import { CategoryIcon } from '../../assets/svgs/CategoryIcon';
import { Link } from "../../components/global/Link";
import { EditIcon } from "../../assets/svgs/EditIcon";
import { DataTableHeadCellData } from "../../components/global/Table/DataTableHeader";
import { DataTree } from "../../components/global/Table/DataTree";
import { AddCategory } from "./AddCategory";
import { EditCategory } from "./EditCategory";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../assets/contexts/AuthContext";
import { useAPI } from "../../hooks/useAPI";
import { CategoryData } from "../../types";

const headCells: DataTableHeadCellData[] = [
  {
    id: 'name',
    disablePadding: true,
    label: 'Name',
    align: 'left',
    searchable: true,
  },
  {
    id: 'edit',
    disablePadding: false,
    label: 'Edit',
    width: '50px',
  },
];

interface CategoryTableData {
  id: any;
  name: any;
  children?: CategoryTableData[];
  edit: JSX.Element;
}

export const Categories = () => {
  const navigate = useNavigate();
  const isLoading = useRef(false);
  const [sIsLoading, setSIsLoading] = useState(false);
  const { isAuthenticated } = useAuth();
  const { fetchData } = useAPI();
  const [categories, setCategories] = useState<CategoryData[]>([]);
  const [rows, setRows] = useState<CategoryTableData[]>([]);

  const onAddCategory = () => {
    navigate('/categories/create');
  }

  const onBulkDelete = async (ids: number[]) => {
    await fetchData('/categories/delete',  { id: ids }, 'POST');
    refetchCategories();
  }

  const refetchCategories = async () => {
    setSIsLoading(true);
    isLoading.current = true;
    const {errors, data} = await fetchData('/categories/all');
    setCategories(data ?? []);
    isLoading.current = false;
    setSIsLoading(false);
  }

  const getRows = (categories: CategoryData[]) => {
    const result: CategoryTableData[] = [];
    for (let i=0; i<categories.length; i++) {
      const item: CategoryTableData = {
        id: `${categories[i].id}`,
        name: <Typography>{categories[i].name}</Typography>,
        edit: <Link to={`/categories/${categories[i].id}`}><EditIcon /></Link>
      }
      if (categories[i].children) {
        const children = getRows(categories[i].children ?? []);
        item.children = children;
      }

      result.push(item);
    }
    return result;
  }

  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      refetchCategories();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    setRows(getRows(categories));
  }, [categories]);

  return (
    <Frame title="Categories" toolbarButtons={(
      <>
        <Button variant="contained" onClick={onAddCategory} startIcon={<CategoryIcon width="22" height="15" color="#FFFFFF" />}>
          Add Category
        </Button>
      </>
    )}>
      <Stack>
        <Routes>
          <Route
            path="/create/"
            element={<AddCategory refetchCategories={refetchCategories} categories={categories} />}
          ></Route>
          <Route
            path="/:category_id/"
            element={<EditCategory refetchCategories={refetchCategories} categories={categories} />}
          ></Route>
        </Routes>
        <DataTree 
          title="Categories" 
          // hideToolBar={true} 
          hideDeleteButton={true} 
          hideIdCheckbox={true} 
          headCells={headCells} 
          rows={rows} 
          onBulkDelete={onBulkDelete} 
          isLoading={sIsLoading}
        />
      </Stack>
    </Frame>
  )
}
